import React, { Component } from 'react';
import injectTapEventPlugin from 'react-tap-event-plugin';
import character from './images/character.png';
import pakage from './images/package.jpg';
// import GSAP from 'react-gsap-enhancer';
import { List, ListItem } from 'material-ui/List';
import Paper from 'material-ui/Paper';
//import FloatingActionButton from 'material-ui/FloatingActionButton';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import PlayIcon from 'material-ui/svg-icons/av/play-circle-filled';
// import PauseIcon from 'material-ui/svg-icons/av/pause-circle-filled';
import DownloadIcon from 'material-ui/svg-icons/action/get-app';
import Player from './ReactPlayer';
import Video from 'react-player';
import Crypto from './images/crypto.png';
import './App.css';

injectTapEventPlugin();

const { TimelineMax } = require('gsap');

const tunes = [
  { label:'The Tree of Enlightenment', time: '13:59', tune: 'Pt1_01_The+Tree+of+Enlightenment.mp3', cd: 1 },
  { label:'A Flash of Lightning', time: '19:21', tune: 'Pt1_02_A+Flash+of+Lightning.mp3', cd: 1 },
  { label:'The Voice of The Buddha', time: '6:30', tune: 'Pt1_03_The+Voice+of+the+Buddha.mp3', cd: 1 },
  { label:'The Old Mendicant', time: '9:57', tune: 'Pt1_04_The+Old+Mendicant.mp3', cd: 1 },
  { label:'We Will Be Back Again', time: '16:06', tune: 'Pt1_05_We+Will+Be+Back+Again.mp3', cd: 1 },
  { label:'The Flower Bank World', time: '9:28', tune: 'Pt2_01_The+Flower+Bank+World.mp3', cd: 2 },
  { label:'The Incalculable', time: '6:09', tune: 'Pt2_02_The+Incalculable.mp3', cd: 2 },
  { label:'Mahamaya', time: '6:02', tune: 'Pt2_03_Mahamaya.mp3', cd: 2 },
  { label:'Interbeing', time: '8:49', tune: 'Pt2_04_Interbeing.mp3', cd: 2 },
  { label:'The Ten Great Aspirations of Samantabhadra Bodhisattva', time: '22:46', tune: 'Pt2_05_The+Ten+Great+Aspirations+of+Samantabhadra+Bodhisattva.mp3', cd: 2 },
];

export default class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      tuneIndex: 0,
      playing: false,
      videoplaying: false,
    };
  }
  componentDidMount(){
    /* new TimelineMax()
      .fromTo(this.character, 3, { opacity: 0}, { opacity: 1})
      .fromTo(this.h1, 2, { opacity: 0, letterSpacing: '2vw'}, { opacity: 1, letterSpacing: 0}, '-=2.2')
      .fromTo(this.h2, 2, { opacity: 0}, { opacity: 1}, '-=1.8');*/
  }

  playTune(tune){
    const isSameTune = this.state.tuneIndex === tune;
    if(isSameTune) this.player.handleToggle();
    this.setState({
      tuneIndex: tune,
      playing: !isSameTune,
    });
  }

  playVideo(play){
    if(this.videoCover){
      new TimelineMax()
        .fromTo(this.videoCover, .25, { opacity: play ? 1 : 0}, { opacity: play ? 0 : 1, onComplete: play ? () => this.videoCover.style.display = 'none' : null });
      //this.setState({ videoplaying: play });
    }
  }

  render() {
    const { tuneIndex, playing, videoplaying } = this.state;
    const docs = [
      { label: 'Press Release', url: 'CG148+Alex+Cline+press+release+6.doc' },
      { label: 'Long Bio', url: 'Alex+Cline+Biography.docx' },
      { label: 'Short Bio', url: 'Alex+short+bio+2016.docx' },
      { label: 'Onesheet', url: 'OOV_Onesheet_Final4.pdf' },
      { label: 'Liner Notes', url: 'BOOKLET.LINER_NOTES.FINAL.pdf' },
      { label: 'Album Cover (JPEG)', url: 'OV.boxCOVER.3000.jpg', 'type': 'img' },
    ];

    const musicians = [
      { name: 'Areni Agbabian', instrument: 'voice' },
      { name: 'Chi Li', instrument: 'erhu, zhonghu, zheng, qin' },
      { name: 'Jeff Gauthier', instrument: 'electric violin' },
      { name: 'Miguel Atwood-Ferguson', instrument: 'electric 5-string violin' },
      { name: 'Maggie Parkins', instrument: 'cello' },
      { name: 'Will Salmon', instrument: 'flute, recorders' },
      { name: 'Nels Cline', instrument: 'electric guitars' },
      { name: 'G.E. Stinson', instrument: 'electric guitars' },
      { name: 'Wayne Peet', instrument: 'electric piano, organ' },
      { name: 'Yuka C. Honda', instrument: 'electric keyboards, samples' },
      { name: 'Scott Walton', instrument: 'bass, keyboard' },
      { name: 'Brad Dutz', instrument: 'vibraphone, hand drums, crotales, gongs, percussion' },
      { name: 'Alex Cline', instrument: 'drums, gongs, percussion' },
      { name: 'Vicki Ray', instrument: 'conductor' },
    ];

    const tune = tuneIndex === -1 ? null : tunes[tuneIndex];

    return (
      <div className="App">
        { tune ? <Player src={`https://s3.amazonaws.com/cryptogramophone/Alex+Cline/CG148/${tune.tune}`} ref={(ref) => (this.player = ref)} title={tune.label} time={tune.time} playing={playing} /> : '' }
        <div className="Oceans page bordered">
          <img ref={(c) => this.character = c} src={character} className="character" alt="Oceans of Vows" />
          <div className="title">
            <Sparky
              timeline={{
                'topTop':{opacity:'0', letterSpacing: '2vw'},
                centerCenter:{opacity:'1', letterSpacing: 0}
              }}
              ref={(c) => this.h1 = c }
              ><h1>Oceans of Vows</h1></Sparky>
            <Sparky
              timeline={{
                'centerCenter+200':{opacity:'0'},
                centerCenter:{opacity:'1'}
              }}
              ref={(c) => this.h2 = c }><h2><span className="alexs">Alex Cline's</span> Flower Garland Orchestra</h2></Sparky>
          </div>
        </div>
        <div className="video bordered">
          <Video
            url="https://vimeo.com/187518937"
            width="92.5vw"
            height="52vw"
            playing={videoplaying}
            onPause={() => this.playVideo(false)}
            onPlay={() => this.playVideo(true)}
            />
          <div className="cover" ref={(c) => this.videoCover = c }>
          <Sparky
            timeline={{
              bottomTop:{opacity:'0'},
              'centerCenter+100':{opacity:'1'},
              'centerCenter-100':{opacity:'1'}
            }}
            className="overlay">
              <div className="pad">
                <div className="playVideo">
                  <RaisedButton
                    label="Play Video"
                    labelColor="#112244"
                    fullWidth
                    onTouchTap={() => this.playVideo(true)}
                    icon={<PlayIcon />}/>
                </div>
                <div className="blurb">
                  <p>Alex Cline’s Oceans of Vows is a deluxe box set of music drawing inspiration from four poems by Buddhist teacher Thich Nhat Hanh,
                    as well as excerpts from the Buddhist text known as the Avatamsaka Sutra.  It’s performed by composer/percussionist Alex Cline
                    and his all-star 14-piece Flower Garland Orchestra, featuring Nels Cline, Yuka C. Honda, and many stalwarts of the L.A. creative music community.</p>
                  <p style={{ fontWeight: 'bold'}}>Available March 10, 2017 on <a href="https://cryptogramophone.com" target="_blank" style={{ color: '#FFF', textDecoration: 'none', borderBottom: '1px dotted #FFF'}}>Cryptogramophone Records</a>.</p>
                </div>
              </div>
            </Sparky>
            <Download name="FGO_concert_300dpi.jpg" credit="David Witham" />
          </div>
        </div>
        {/* <div
          className="Concert bordered">
          <Sparky
            timeline={{
              bottomBottom:{opacity:'0'},
              'centerCenter-100':{opacity:'1'}
            }}
            className="overlay">
            <div className="pad">
              <h2>Oceans of Vows by Alex Cline’s Flower Garland Orchestra</h2>
              <p>Alex Cline’s Oceans of Vows is a deluxe box set of music drawing inspiration from four poems by Buddhist teacher Thich Nhat Hanh, as well as excerpts from the Buddhist text known as the Avatamsaka Sutra.  It’s performed by composer/percussionist Alex Cline and his all-star 14-piece Flower Garland Orchestra, featuring Nelx Cline, Yuka C. Honda, and many stalwarts of the L.A. creative music community.</p>
            </div>
          </Sparky>
        </div> */}
        <Page className="Alex1 diptych bordered">
          <div className="left">
            <div className="overlady">
              <div className="pad">
                <Table cd={1} current={tuneIndex} playTune={(t) => this.playTune(t)} player={this.player} />
                <Table cd={2} current={tuneIndex} playTune={(t) => this.playTune(t)} player={this.player} />
              </div>
            </div>
          </div>
          <Sparky
            timeline={{
              topBottom: { backgroundPosition: '63% 80%'},
              bottomTop: { backgroundPosition: '63% 0%'}
            }}
            className="right">
            <Download name="Alex_Cline_Photo_1.jpg" credit="Ernestine Lona" />
          </Sparky>
        </Page>
        <div className="Package bordered">
          <img src={pakage} alt="Oceans of Vows - The Whose Package" />
            <Download name="Package_Mockup.jpg" />
        </div>

        <Page className="Alex2 diptych bordered">
          <div className="left">
              <div className="overlay">
                <div className="pad">
                  <h2>Press Material</h2>
                  <p>Press and media can find musician bios, press releases, onesheet and liner notes below.  High resolution images can be downloaded by clicking the download icon on the photographs.</p>
                  <Paper>
                    <List>
                    { docs.map((item, key) => <ListItem
                        key={key}
                        rightIcon={<DownloadIcon color="#FFFFFF" />}
                        onClick={() => window.open(`https://s3.amazonaws.com/cryptogramophone/Alex+Cline/CG148/${item.type === 'img' ? 'Photos' : 'Docs'}/${item.url}`, '_blank')}
                        primaryText={item.label} />) }
                  </List>
                </Paper>
              </div>
            </div>
          </div>
          <Sparky
            timeline={{
              bottomTop: { backgroundPosition: '63% 10%'},
              bottomBottom: { backgroundPosition: '63% 80%'}
            }}
            className="right">
            <Download name="Alex_Cline_Photo_2.jpg" credit="Ernestine Lona" />
          </Sparky>
        </Page>

        <div className="Credits diptych bordered">
              <div className="left">
                <div className="overlay">
                  <div className="pad">
                { musicians.map((item, key) => <div key={key}><b>{item.name}</b>, {item.instrument}</div> )}
                <div className="label">Pre-recorded voices (in order of appearance)</div>
                <div className="voices">Thich Nhat Hanh</div>
                <div className="voices">Brother Phap Khe</div>
                <div className="voices">Due Nguyen</div>
                <div className="voices">Brother Phap Hai</div>
                <div className="voices">Sister Dang Nghiem</div>
                </div>
                </div>
                </div>
              <div className="right">
                <div className="overlay">
                  <div className="pad">
  <div className="extras">
      <p>All music composed by Alex Cline, Singing Feathers Music (BMI). </p>
      <p>
      Recorded October 13 and 14, 2015, at the Bridge Recorders, Glendale, CA. <br />
      Mixed and mastered at Dogmatic Studios, Burbank, CA. <br />
      Recorded, mixed, and mastered by Rich Breen. <br />
      Additional recording done at Newzone Studios, Los Angeles, CA; engineer: Wayne Peet.<br />
      Great bell at Deer Park Monastery, Escondido, CA, recorded by Javier Bennassar. <br />
      Package design by Steve Child & Alex Cline. Artwork & graphics by Steve Child. <br />
      Calligraphy by Paul Chu. <br />
    Photography: individual musicians: Ernestine Lona; full ensemble in concert: David Witham (video still), in studio: Karen Cline; Thich Nhat Hanh and friends: Don Farber.
      </p>

      <p>Composition and recording were made possible by a grant from the Shifting Foundation.</p>
      <p>Produced by Alex Cline.</p>
  </div>

              </div>
          </div>
          </div>
        </div>

        <Page className="Contact diptych bordered">
          <div className="left">
            <div className="logo"><a href="mailto:jeff@cryptogramophone.com"><img src={Crypto} alt="Cryptogramophone" /></a></div>
          </div>
          <div className="right">
          <div className="pad">
<table>
  <tbody>
<tr><td className="label">Label Contact</td><td className="content"><a href="mailto:jeff@cryptogramophone.com">Jeff Gauthier</a>, Cryptogramophone</td></tr>

   <tr><td className="label">Distribution</td><td className="content">Mack Ave. Records<br />
    US: <a href="mailto:cameron@mackavenue.com">Cameron Smith</a> <br />
  International: <a href="mailto:casey@weareflex.com">Casey Conroy</a> </td></tr>
<tr><td className="label">Press</td><td className="content"><a href="mailto:stevie.buono@gmail.com">Steven Buono</a> </td></tr>
   <tr><td className="label">Radio</td><td className="content"><a href="mailto:mrini@pacbell.net">Mark Rini</a>, Groov Marketing</td></tr>
   </tbody>
   </table>
          </div>
          </div>

        </Page>
      </div>
    );
  }
}
/*
<div className="Images bordered">
  {images.map((item, key) => <div key={key} className="Image" style={{ height: `${83 / images.length}vw`}}><a href={item.url} title={item.title} target="_blank"><DownloadIcon /></a></div>)}
</div>
*/

const Download = ({ name, credit }) => {
  return (
    <div className="download">
      <FlatButton
        label="Hi-Res"
        labelPosition="before"
        backgroundColor="rgba(0,0,0,.4)"
        className="bouton"
        icon={<DownloadIcon />}
        onTouchTap={() => window.open(`https://s3.amazonaws.com/cryptogramophone/Alex+Cline/CG148/Photos/${name}`, '_blank')}
        />
      <div className="credits">{ credit && <div>Photo: {credit}</div> }</div>
    </div>
  );
}
/*
<FloatingActionButton
  tooltip="Download this image in high resolution"
  tooltipPosition="top-left"
  className="bouton"
  mini
  onTouchTap={() => window.open(`https://s3.amazonaws.com/cryptogramophone/Alex+Cline/CG148/Photos/${name}`, '_blank')}>
  <DownloadIcon />
</FloatingActionButton>
*/
const Table = ({ cd, playTune, current, player }) => {
  return (
    <div>
    <h2 style={{ marginTop: cd === 2 ? 20 : 0}}>CD{cd}</h2>
    <Paper>
      <List>
          {tunes.map((item, key) => cd === item.cd && <ListItem
            key={key}
            onClick={() => playTune(key)}
            primaryText={item.label}
            leftIcon={<div className="time">{item.time}</div>}
            rightIcon={current === key && player && player.toggleIcon ? player.toggleIcon : <PlayIcon color="#FFFFFF" />} /> )}

      </List>
    </Paper></div>
  );
} ;

const Sparky = (props) => {
  return (<div {...props} />);
}

const Page = (props) => {
  return (<div {...props} />);
}



// WEBPACK FOOTER //
// ./src/App.js